import classNames from "classnames";
import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import RolesList from "./RolesList";
import ErrorPage from "../../../components/error/ErrorPage";

const RolesListWrapper = () => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();
    const canSeeRoles = userCan('list_roles', 'roles') && userCan('admin_roles', 'roles');

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Roles', href: menuRoutes.roles.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de roles" breadcrumb={breadCrumb}>
                    <Button
                        color="primary"
                        onClick={() => { navigate(menuRoutes.roles.create) }}
                        className={cn('mt-3 md:mt-0', [classNames({ 'hidden': !userCan('create_roles', 'roles') })])}
                    >
                        Crear rol
                    </Button>
                </PageHeader>
                {canSeeRoles ? <RolesList /> : <ErrorPage />}
            </FiltersProvider>
        </Fragment>
    );
}

export default RolesListWrapper;